/* ============
 * OrderPickups Index
 * ============
 *
 * This page shows the list of orderPickups.
 */
import { mapGetters, mapMutations } from 'vuex';
import orderPickupService from './../../../../services/orderPickup';
import shippingService from './../../../../services/shippingProvider';
import accountService from './../../../../services/account';
import store from './../../../../store';
import SearchMixin from './../../../../mixins/search';
import debounce from 'debounce';
import moment from 'moment';
export default {
  data() {
    return {
      shippingProviderOptions: [],
      shippingProvider: 'All',
      statusOptions: [
        {
          id: 'All',
          name: this.$t('static.orderPickups.index.shippingStatuses.all'),
            },
        {
          id: 'New',
          name: this.$t('static.orderPickups.index.shippingStatuses.new'),
            },
        {
          id: 'Picked',
          name: this.$t('static.orderPickups.index.shippingStatuses.picked'),
            },
        {
          id: 'In Transit',
          name: this.$t('static.orderPickups.index.shippingStatuses.inTransit'),
            },
        {
          id: 'Delivered',
          name: this.$t('static.orderPickups.index.shippingStatuses.delivered'),
            },
        {
          id: 'Cancelled',
          name: this.$t('static.orderPickups.index.shippingStatuses.cancelled'),
            },
        ],
      status: 'All',
      search: '',
      defaulExpand: false,
      loading: true,
      limit: 25,
    };
  },

  computed: {
    ...mapGetters({
      account: 'account',
      orderPickups: 'paginatedOrderPickups',
    }),


    orderPickupTable() {
      return this.orderPickups.items.map((item) => ({
        id: item.id,
        orderId: item.orderId,
        organizationId: item.organizationId,
        shippingProviderId: item.shippingProviderId,
        shippingStatusId: item.shippingStatusId,
        number: item.number,
        organization: item.organization,
        shippingProvider: item.shippingProvider,
        shippingStatus: (item.shippingStatus === 'In Transit') ? this.$t('static.orderPickups.index.shippingStatuses.inTransit') : this.$t('static.orderPickups.index.shippingStatuses.' + item.shippingStatus.toLowerCase()),
        pickupPriority: item.pickupPriority,
        note: item.note,
        pickupBy: item.pickupBy,
        pickupDate: item.pickupDate ? moment(item.pickupDate).format('D/M/Y') : null,
        shippingDate: item.shippingDate ? moment(item.shippingDate).format('D/M/Y') : null,
        deliveryDate: item.deliveryDate ? moment(item.deliveryDate).format('D/M/Y') : null,
        createdAt: moment(item.createdAt).format('D/M/Y'),
        trackingUrl: item.trackingUrl,
        customerName: item.customerName,
      }));
    },

    /**
     * If the user has the EDI module.
     *
     * @return {Boolean}
     */
    hasEdiModule() {
      const modules = this.account.modules.map(m => m.name);
      return modules.indexOf('EDI') > -1;
    },

    /**
     * If the user has the Appointment module.
     *
     * @return {Boolean}
     */
    hasAppointmentModule() {
      const modules = this.account.modules.map(m => m.name);
      return modules.indexOf('Appointment') > -1;
    },
  },

  watch: {
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, this.limit);
    },

  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    perPage(size){
      accountService.rememberPerPage('post', {from: 'order_pickups', perPage: size })
      .then((data) => {
        this.limit = data.size;
      }).catch((error) => {
        console.log(error);
      });
    },

    /**
     * Builds inner sidebar.
     */
    buildInnerSidebar() {
      const sidebar = [{
        title: this.$t('layouts.sidebar.orders'),
        options: [
          {
            title: this.$t('layouts.sidebar.products'),
            route: {
              name: 'orders.index',
              query: {
                filter: 'Product',
              },
            },
                    },
          {
            title: this.$t('layouts.sidebar.services'),
            route: {
              name: 'orders.index',
              query: {
                filter: 'Service',
              },
            },
                    },
          {
            title: this.$t('layouts.sidebar.all'),
            route: {
              name: 'orders.index',
            },
                    }
                ],
        button: {
          title: `+ ${this.$t('static.orders.create.title')}`,
          route: {
            name: 'orders.create',
          },
        },
            }];

      if (this.hasAppointmentModule) {
        sidebar.push({
          title: this.$t('layouts.sidebar.booking'),
          options: [
            {
              title: this.$t('layouts.sidebar.upcoming'),
              route: {
                name: 'appointments.index',
                query: {
                  appointment: 'upcoming',
                },
              },
                    },
            {
              title: this.$t('layouts.sidebar.done'),
              route: {
                name: 'appointments.index',
                query: {
                  appointment: 'done',
                },
              },
                    },
            {
              title: this.$t('layouts.sidebar.calendar'),
              route: {
                name: 'appointments.index',
                query: {
                  appointment: 'calendar',
                },
              },
                    },
                ],
          button: {
            title: `+ ${this.$t('static.appointments.create.title')}`,
            route: {
              name: 'orders.create',
            },
          },
        });
      }

      if (this.hasEdiModule) {
        sidebar.push({
          title: this.$t('layouts.sidebar.orderFilter'),
          options: [
            {
              title: this.$t('layouts.sidebar.newOrders'),
              route: {
                name: 'orders.index',
                query: {
                  filter: 'created',
                },
              },
                    },
            {
              title: this.$t('layouts.sidebar.confirmed'),
              route: {
                name: 'orders.index',
                query: {
                  filter: 'confirmed',
                },
              },
                    },
            {
              title: this.$t('layouts.sidebar.inTransit'),
              route: {
                name: 'orders.index',
                query: {
                  filter: 'processed',
                },
              },
                    },
            {
              title: this.$t('layouts.sidebar.recieved'),
              route: {
                name: 'orders.index',
                query: {
                  filter: 'received',
                },
              },
                    },
            {
              title: this.$t('layouts.sidebar.invoiced'),
              route: {
                name: 'orders.index',
                query: {
                  filter: 'invoiced',
                },
              },
                    },
            {
              title: this.$t('layouts.sidebar.credited'),
              route: {
                name: 'orders.index',
                query: {
                  filter: 'credited',
                },
              },
                    },
            {
              title: this.$t('layouts.sidebar.cancelled'),
              route: {
                name: 'orders.index',
                query: {
                  filter: 'cancelled',
                },
              },
                    },
            {
              title: this.$t('layouts.sidebar.complete'),
              route: {
                name: 'orders.index',
                query: {
                  filter: 'completed',
                },
              },
                    },
            {
              title: this.$t('layouts.sidebar.all'),
              route: {
                name: 'orders.index',
              },
                    },
                ],
        });
      }

      /**
       * Order pickups sidebar
       */
      sidebar.push({
        title: this.$t('layouts.sidebar.orderPickups.title'),
        options: [
          {
            title: this.$t('layouts.sidebar.orderPickups.viewAll'),
            route: {
              name: 'orderPickups.index',
              query: {
                filter: 'all',
              },
            },
                }
                ]
      });

      this.setInnerSidebar(sidebar);
    },

    destroyed() {
      this.unsetInnerSidebar();
      store.dispatch('resetOrders');
    },

    onChangeSearch: function(name, value) {
      store.dispatch('setOrderPickupQuery', { page: 1, limit: this.limit, search: value });
      this.all(1, this.limit);
    },

    /**
     * Fetches paginated orders.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all: debounce(function(page, limit) {
      this.defaulExpand = false;
      this.loading = true;
      // let query = { page: page, limit: limit, search: this.searchQuery.search };
      // store.dispatch('setOrderQuery', query);
      // this.search = this.searchQuery.search;
      const params = {
        page,
        limit,
        search: this.search,
        status: this.status,
        shippingProvider: this.shippingProvider,
      };
      orderPickupService.items(params)
        .then(() => {
          this.loading = false;
          if (this.$route.params.number) {
            this.defaulExpand = true;
            this.$route.params.number = null;
          } else {
            this.defaulExpand = false;
          }

        }).catch(() => {
          this.loading = false;
        });
    }, 800),

    onChangeSearch: function(name, value) {
      this.search = value;
      this.all(1, this.limit);
    },

    providerList() {
      Promise.all([
                shippingService.all({})
            ]).then((data) => {
        console.log(data[0]);
        this.shippingProviderOptions = data[0].map((item) => ({ id: item.id, name: item.name }));
        this.shippingProviderOptions.unshift({ id: 'All', name: this.$t('static.shippingProviderAll') })
      }).catch((error) => {
        console.log(error);
      });
    },

    rowClicked(row) {
      this.$refs.orderPickupData.toggleRowExpansion(row);
    }
  },

  created() {
    this.buildInnerSidebar();
    this.providerList();
    
    accountService.rememberPerPage('get', {from: 'order_pickups'})
    .then((data) => {
      this.limit = data.size;
      this.all(1, this.limit);
    }).catch((error) => {
      console.log(error);
    });

    if (this.$route.params.number) {
      this.search = this.$route.params.number;
    }
  },

  components: {
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VSelect: require('./../../../../components/form/select/select.vue'),
  },

  mixins: [
        SearchMixin,
    ],

}



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/orderPickups/index/index.js